import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PPIRevenueReportCtrl from '../../../components/reportsComponents/accountmanagement/ppiRevenueReportCtrl';
import PPIRevenueReportTable from '../../../components/reportsComponents/accountmanagement/ppiRevenueReportTable';
const pageTitle = 'PPI Revenue Report'
let PPIRevenueReportForm={
	formPPIRevenueReportInfo:{}
}

class PPIRevenueReport extends Component {
	constructor() {
		super();
		this.state = {
            fromDate:'',
            toDate:''
		}
	}
	componentWillMount = () => {
		document.title = pageTitle;
		
    }
    onPPIRevenueFieldChange=(key, value)=>{
        this.setState({[key]:value});
    }
	render() {
		return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> PPI Revenue Report</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <PPIRevenueReportCtrl onPPIRevenueFieldChange={(key, value)=>this.onPPIRevenueFieldChange(key, value)}
                    initCallBack={(frm)=>{
						PPIRevenueReportForm.formPPIRevenueReportInfo=frm;
                    }} fromdate={this.state.fromDate} todate={this.state.toDate}/>
                    <PPIRevenueReportTable />
                </div>
            </Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		
	}
};

export default withRouter(connect(mapStateToProps)(PPIRevenueReport));
